// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"deb86c0d","455":"269184ee","977":"304c1de4"}[chunkId] + ".chunk.js";
};